/**
 * wowjs is a browser IIFE that assigns WOW onto `this`.
 * Under Vite ESM, `this` is undefined, so run it against `window`.
 */
import wowSource from '../../node_modules/wowjs/dist/wow.js?raw';

const source = wowSource.replace(/\}\)\.call\(this\);?\s*$/, '}).call(window);');
// eslint-disable-next-line no-new-func
const load = new Function(`${source}; return window.WOW;`);
const WOWConstructor = load();

export default { WOW: WOWConstructor };
